import { createFeature, createReducer, on } from '@ngrx/store';

import { DynamicComponent } from '@priva/components/dynamic';

import { closeDialog, openDialog } from './app-state.actions';
import { AppState, initialAppState } from './app.state';

export const appFeatureKey = 'app';

/* istanbul ignore next, standard reducer pattern */
const reducer = createReducer<AppState>(
    initialAppState,

    on(openDialog, (state, action): AppState => {
        const activeDialogs = [
            ...state.activeDialogs.filter((d) => d.component !== action.dialog.component),
            action.dialog,
        ];
        return { ...state, activeDialogs };
    }),

    on(closeDialog, (state, _action): AppState => {
        const activeDialogs: DynamicComponent[] = [...state.activeDialogs];
        activeDialogs.pop();
        return { ...state, activeDialogs };
    }),
);

export const appStateFeature = createFeature({
    name: appFeatureKey,
    reducer,
});
